export default __webpack_public_path__ + "static/media/aca-logo.a6206813.png";